module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"tab":{"all":"所有評論","video":"視頻點評"}}}')
  delete Component.options._Ctor
}
